import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const ProgressBar = ({ ratio, className }) => (
	<div className={classnames(styles.progressBar, className)} style={{ width: `${ratio * 100}%` }} />
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/atoms/ProgressBar/index.js